<template>
  <div class="nk-app-root">
    <!-- main @s -->
    <div class="nk-main">
      <!-- wrap @s -->
      <div class="nk-wrap nk-wrap-nosidebar">
        <!-- content @s -->
        <div class="nk-content">
          <div class=" nk-block-middle nk-auth-body wide-xs" v-if="rows.length == 0">
            <div class="card card-bordered">
              <div class="card-inner card-inner-lg">
                <div class="brand-logo pb-4 text-center">
                  <img
                      class="logo"
                      :src="config != null ? config.f_logo_blanco.url : ''"
                      :alt="config != null ? config.nombre : ''"
                  />
                </div>
                <form @submit.prevent="getRecibosNominaEmpleado">
                  <div class="form-group">
                    <div class="form-label-group">
                      <label class="form-label">
                        CURP o RFC
                      </label>
                    </div>
                    <input
                        type="text"
                        required
                        class="form-control form-control-lg text-uppercase"
                        placeholder="Ingresa tu CURP o RFC"
                        v-model="form.rfc_curp"
                    />
                  </div>
                  <div class="form-group">
                    <button class="btn btn-lg btn-primary btn-block">
                      Buscar recibos
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>

          <div class="nk-block-middle nk-auth-body wide-md" v-else>
            <q-table
                title-class="text-secondary text-bold"
                ref="tableRef"
                row-key="id_recibo"
                :rows="rows"
                :rows-per-page-options="[10, 25, 50]"
                :columns="COLUMNS"
                @request="onRequest"
                v-model:pagination="pagination"
            >
              <template v-slot:top="">
                <div class="column">
                  <span class="text-primary text-bold text-h6">
                    <q-btn
                        rounded
                        unelevated
                        no-caps
                        padding="none"
                        size="16px"
                        icon="arrow_back"
                        flat
                        :ripple="false"
                        :label="nombre_empleado != null ? `Recibos de ${nombre_empleado}` : ''"
                        @click="back()"
                    />
                  </span>
                </div>
              </template>
              <template v-slot:body-cell-f_recibo="props">
                <q-td :props="props">
                  <a
                      round
                      unelevated
                      color="primary"
                      :href="props.row.f_recibo.url"
                      :download="props.row.f_recibo.id_archivo"
                      target="_blank"
                      v-if="props.row.f_recibo.url != '#'"
                  >
                    <span>
                      Descargar recibo
                    </span>
                  </a>
                  <span class="text-grey-8" v-else>
                      No se ha subido el recibo aún
                  </span>
                </q-td>
              </template>
            </q-table>
          </div>
          <div class="nk-footer nk-auth-footer-full">
            <div class="container wide-lg">
              <div class="row g-3">
                <div class="col-lg-12">
                  <div class="nk-block-content text-center">
                    <p class="text-soft">
                      © {{ year }} | Hecho con
                      <i class="ni ni-coffee-fill text-blue"></i> y
                      <i class="ni ni-heart-fill text-danger"></i> en
                      <a
                          href="https://tekoestudio.com"
                          class="text-blue"
                          target="_blank"
                      >Teko Estudio</a
                      >
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- wrap @e -->
      </div>
      <!-- content @e -->
    </div>
    <!-- main @e -->
  </div>
</template>

<script>
import {reactive, ref, toRefs} from "vue";
import Swal from "sweetalert2";
import {useApi} from "@/use/useApi";

export default {
  name: "MisRecibos",
  setup() {
    const COLUMNS = [
      {
        name: 'fecha_formateada',
        label: 'Fecha',
        align: 'left',
        field: row => row.fecha_formateada,
        format: val => `${val}`,
        sortable: false,
        classes: 'text-grey-8',
      },
      {name: 'f_recibo', label: 'Recibo'}
    ]
    //Data
    const year = ref(new Date().getFullYear());
    const {loading, make} = useApi();
    const form = ref({
      rfc_curp: "",
    });
    const config = ref();
    const state = reactive({
      loading: false,
      tableRef: null,
      rows: [],
      pagination: {
        page: 1,
        rowsPerPage: 10,
        rowsNumber: 0,
        sortBy: 'fecha',
        descending: 'DESC'
      },
      nombre_empleado: null,
    });

    async function getRecibosNominaEmpleado() {

      const params = {
        rfc_curp: form.value.rfc_curp,
        config: {...state.pagination}
      };

      loading.message = "Validando información";

      let {data} = await make("public/get-recibos-nomina-empleado", params);

      if (data === null) {
        Swal.fire(
            "Error",
            "Ocurrió un error al conectarse con el servidor",
            "error"
        );
      } else {
        if (data.error) {
          Swal.fire("Error", data.message, "error");
          state.nombre_empleado = null;
          state.rows = [];
          state.pagination.rowsNumber = 0;
        } else {
          if (data.rows.length == 0) Swal.fire("Información", `No se encontraron recibos para el empleado <b>${data.nombre_empleado} </b>`, "info");

          state.nombre_empleado = data.nombre_empleado;
          state.rows = data.rows;
          state.pagination.rowsNumber = data.rowsNumber;
        }
      }
    }

    async function getConfig() {
      let {data} = await make("public/get-config", {});
      if (data === null) {
        Swal.fire(
            "Error",
            "Ocurrió un error al conectarse con el servidor",
            "error"
        );
      } else {
        if (data.error) {
          Swal.fire("Error", data.message, "error");
        } else {
          config.value = data.model;

          document.title = config.value.nombre;
        }
      }
    }

    async function onRequest(props) {

      const {page, rowsPerPage, sortBy, descending} = props.pagination;

      state.pagination.page = page;
      state.pagination.rowsPerPage = rowsPerPage;
      state.pagination.sortBy = sortBy;
      state.pagination.descending = descending;

      await getRecibosNominaEmpleado();

      state.loading = false;
    }

    getConfig();

    return {
      config,
      year,
      loading,
      COLUMNS,
      ...toRefs(state),
      form,
      getRecibosNominaEmpleado,
      onRequest,
      back: () => location.reload()
    };
  },
};
</script>

<style lang="scss" scoped>
.logo {
  height: 100px;
}

.corazon {
  color: darkred;
}

input,
textarea,
select {
  text-transform: initial;
}
</style>